import { AppDispatch } from "../../../app/store";
import { getBookingType } from "../../../components/BookingForm/utils/booking.utils";
import { clearFloors, clearInputs, setInputs } from "../slices/booking.slice";
import { NotSerializedBookingMode } from "../typings/booking-inputs";

export type BookingFormBooker = {
  sub: string;
  firstName: string;
  surname: string;
  email: string;
};

/**
 * Clears booking wizard state and primes Redux for a new booking of the given mode,
 * matching the payload set when the user picks a type on the mode selection screen.
 */
export function primeBookingFormForMode(
  dispatch: AppDispatch,
  booker: BookingFormBooker,
  mode: NotSerializedBookingMode
): void {
  dispatch(clearInputs());
  dispatch(clearFloors());
  dispatch(
    setInputs({
      mode,
      bookingType: getBookingType(mode),
      usersBookedFor: [
        {
          userId: booker.sub,
          firstName: booker.firstName,
          surname: booker.surname,
          isExternal: false,
          email: booker.email
        }
      ],
      isUserBookedBy: true,
      automatedSeating: false
    })
  );
}
